import { Injectable } from '@angular/core';
import { ApiClient } from '../api.client';
import {
  CustomerPriceListItem,
  ProductPriceListItem
} from '../../models/price-lists';

@Injectable()
export class PriceListService {
  constructor(private http: ApiClient) {}

  getByProductId(productId: number) {
    return this.http.get<ProductPriceListItem[]>(
      `price-list?product_id=${productId}`
    );
  }

  getByCustomerId(customerId: number) {
    return this.http.get<CustomerPriceListItem[]>(
      `price-list?customer_id=${customerId}`
    );
  }
}
